import { render, staticRenderFns } from "./soch3dDashboard.vue?vue&type=template&id=0aa2c6be&"
import script from "./soch3dDashboard.vue?vue&type=script&lang=js&"
export * from "./soch3dDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports